module.exports = __webpack_public_path__ + "ptc_nakagawa_K2.d20e1c91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_K2.jpg
// module id = 0QFp
// module chunks = 0